import './home-landing.css';

import * as React from 'react';
import { Link } from 'react-router-dom';

import SignInPanel from './sign-in-panel';

const VIDEO_ID = 'ItHs62NxCTM';
const ICONS = 'https://betting-books.stevedavo.com/resources/icons/';
const BANNERS = 'https://betting-books.stevedavo.com/resources/banners/promotion/';

// The books API needs a login, so these public counts and examples are kept here. Update them when the catalogue changes.
const SHELVES = [
  {
    slug: 'football',
    name: 'Football',
    count: 41,
    books: [
      ['Football Made Simple', 'football-made-simple-icon.jpg'],
      ['Last Half Football', 'last-half-football-icon.jpg'],
      ['Football Trading Tips', 'football-trading-tips-icon.jpg']
    ]
  },
  {
    slug: 'betting-bots-software',
    name: 'Betting bots and software',
    note: 'Windows only',
    count: 30,
    books: [
      ['Lay The Draw Soccer Bot', 'lay-the-draw-soccer-bot-icon.png'],
      ['Auto Profit Soccer Deluxe', 'auto-profit-soccer-deluxe-icon.jpg'],
      ['Magic Soccer Bot', 'magic-soccer-bot-icon.png']
    ]
  },
  {
    slug: 'horse-racing',
    name: 'Horse racing',
    count: 27,
    books: [
      ['Betfair ATM', 'betfair-atm-icon.jpg'],
      ['Make Betting Pay', 'make-betting-pay-icon.jpg'],
      ['Smart Racing Trader', 'smart-racing-trader-icon.jpg']
    ]
  },
  {
    slug: 'staking-plans',
    name: 'Staking plans',
    count: 25,
    books: [
      ['Multi Bets', 'multi-bets-icon.jpg'],
      ['Double Dutch2', 'double-dutch2-icon.jpg'],
      ['Diabolical Staking', 'diabolical-staking-icon.jpg']
    ]
  },
  {
    slug: 'maxs-excellent-software',
    name: "Max's Excellent Software",
    count: 9,
    books: [['Football 10', 'football-10-icon.jpg'], ['Dutch 5', 'dutch-5-icon.jpg'], ['Spread-5', 'spread-5-icon.jpg']]
  },
  {
    slug: 'greyhounds',
    name: 'Greyhounds',
    count: 7,
    books: [
      ['Greyhound UK Rater', 'greyhound-uk-rater-icon.jpg'],
      ['Lay Grey Bot', 'lay-grey-bot-icon.jpg'],
      ['Greyhound Dutch Traps Bot', 'greyhound-dutch-traps-bot-icon.jpg']
    ]
  },
  {
    slug: 'tennis',
    name: 'Tennis',
    count: 6,
    books: [
      ['Smart Tennis Trading', 'smart-tennis-trading-icon.jpg'],
      ['Tennis Profit Pool', 'tennis-profit-pool-icon.jpg'],
      ['Tennis Price Monitor', 'tennis-price-monitor-icon.jpg']
    ]
  },
  {
    slug: 'cricket',
    name: 'Cricket',
    count: 4,
    books: [
      ['2020 Cricket Trading', '2020-cricket-trading-icon.jpg'],
      ['Cricket Trader', 'cricket-trader-icon.jpg'],
      ['Trading Mindset', 'trading-mindset-icon.jpg']
    ]
  }
];

const FEATURED = [
  ['promotion-1.jpg', 'Football Made Simple'],
  ['promotion-2.jpg', 'Last Half Football'],
  ['promotion-5.jpg', 'Zero Risk Trader'],
  ['promotion-6.jpg', 'Pro Betfair Trading'],
  ['promotion-7.jpg', 'Smart Racing Trader'],
  ['promotion-8.jpg', 'Football Trading Tips']
];

const QUESTIONS = [
  [
    'How do I get access?',
    'Register with your name and email address, then open the link we email you to activate your account. After that, log in to see your subscribed products.'
  ],
  ['Are any books free?', 'Yes. A small number of books are free to read once you have logged in.'],
  ['Will the bots and software run on my computer?', 'The betting bots and software shelf is for Windows only.'],
  ['Can I share my account?', 'No. Your account is for you alone, and if we find a shared account we block it immediately.']
];

// TypeScript 2.8's types lack these attributes, so they are passed by spread
const lazyLoading: any = { loading: 'lazy', decoding: 'async' };
const videoPermissions: any = { allow: 'autoplay; encrypted-media', allowFullScreen: true };

export interface IHomeLandingProps {
  loginError: boolean;
  handleLogin: Function;
}

export interface IHomeLandingState {
  playVideo: boolean;
}

export class HomeLanding extends React.Component<IHomeLandingProps, IHomeLandingState> {
  state: IHomeLandingState = { playVideo: false };

  playVideo = () => this.setState({ playVideo: true });

  render() {
    return (
      <div className="landing">
        <section className="landing-hero">
          <div className="landing-inner landing-hero-grid">
            <div className="landing-hero-copy">
              <h1>Betting guides, systems and software, all on one shelf</h1>
              <p>
                More than 150 titles for football, horse racing, greyhounds, tennis and cricket, along with betting bots and staking plans.
              </p>
              <Link to="/register" className="landing-cta">
                Register a new account
              </Link>
            </div>
            <SignInPanel loginError={this.props.loginError} handleLogin={this.props.handleLogin} />
          </div>
        </section>

        <section className="landing-section landing-intro">
          <div className="landing-inner landing-intro-grid">
            <div className="landing-video">
              {this.state.playVideo ? (
                <iframe
                  title="Betting Bookshop introduction"
                  src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1`}
                  {...videoPermissions}
                />
              ) : (
                <button type="button" onClick={this.playVideo} aria-label="Play the Betting Bookshop introduction video">
                  <img src={`https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`} alt="" {...lazyLoading} />
                  <span className="landing-video-play" />
                </button>
              )}
            </div>
            <div>
              <h2>How it works</h2>
              <ol className="landing-steps">
                <li>
                  <strong>Register</strong> with your name and email address.
                </li>
                <li>
                  <strong>Activate</strong> your account using the link we email you.
                </li>
                <li>
                  <strong>Log in</strong> to read your subscribed products in the browser.
                </li>
              </ol>
            </div>
          </div>
        </section>

        <section className="landing-section">
          <div className="landing-inner">
            <h2>What's on the shelves</h2>
            <div className="landing-shelves">
              {SHELVES.map(shelf => (
                <article key={shelf.name} className="landing-shelf">
                  <div className="landing-shelf-covers">
                    {shelf.books.map(([title, icon]) => <img key={icon} src={ICONS + icon} alt={title} {...lazyLoading} />)}
                  </div>
                  <h3>
                    <a href={`/shelves/${shelf.slug}.html`}>{shelf.name}</a>
                  </h3>
                  <p>
                    {shelf.count} titles
                    {shelf.note ? `, ${shelf.note}` : ''}
                  </p>
                </article>
              ))}
            </div>
            <p className="landing-also">
              Also available: <a href="/shelves/ice-hockey.html">ice hockey</a>, <a href="/shelves/baseball.html">baseball</a> and{' '}
              <a href="/shelves/casino-roulette.html">roulette</a>. <a href="/shelves/index.html">Browse all shelves</a>.
            </p>
          </div>
        </section>

        <section className="landing-section landing-featured">
          <div className="landing-inner">
            <h2>Featured titles</h2>
            <div className="landing-banners">
              {FEATURED.map(([image, title]) => (
                <div key={image} className="landing-banner">
                  <img src={BANNERS + image} alt={title} {...lazyLoading} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="landing-section">
          <div className="landing-inner landing-questions">
            <h2>Common questions</h2>
            <div>
              {QUESTIONS.map(([question, answer]) => (
                <details key={question}>
                  <summary>{question}</summary>
                  <p>{answer}</p>
                </details>
              ))}
              <p className="landing-risk">Betting involves the risk of losing money. Only bet what you can afford to lose.</p>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default HomeLanding;
